module.exports = __webpack_public_path__ + "img/noor.7e4036ac.png";